<template>
  <div class="employeeslist">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Probated Extension</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Probated Extension</li>
                </ul>
              </div>
            </div>
          </div>

          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <v-data-table
                :headers="headers"
                :items="probatedEmployees"
                :loading="loading"
                loading-text="Loading... Please wait"
                sort-by=""
                class="elevation-1 table"
              >
                <template v-slot:[`item.profile`]="{ item }">
                  <h2 class="table-avatar">
                    <router-link
                      :to="{
                        name: 'employeedetail',
                        params: { id: item.probatedEmployee.employee.id },
                      }"
                      class="avatar"
                      ><img
                        alt=""
                        src="~@/assets/profiles/avatar-02.jpg"
                        v-if="!item.probatedEmployee.employee.passportPhoto" />
                      <img
                        alt=""
                        :src="
                          media + item.probatedEmployee.employee.passportPhoto
                        "
                        width="38"
                        v-if="item.probatedEmployee.employee.passportPhoto"
                    /></router-link>
                    <router-link
                      :to="{
                        name: 'employeedetail',
                        params: { id: item.probatedEmployee.employee.id },
                      }"
                      v-if="item.probatedEmployee.employee.status == 3"
                      ><p>
                        {{
                          item.probatedEmployee.employee.firstName +
                          " " +
                          item.probatedEmployee.employee.lastName
                        }}
                      </p>
                      <span>{{
                        item.probatedEmployee.employee.designation.name
                      }}</span>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'employeedetail',
                        params: { id: item.probatedEmployee.employee.id },
                      }"
                      v-else
                      >{{
                        item.probatedEmployee.employee.firstName +
                        " " +
                        item.probatedEmployee.employee.lastName
                      }}
                      <span>{{ item.employee.designation.name }}</span>
                    </router-link>
                  </h2>
                </template>
                <template v-slot:[`item.createdAt`]="{ item }">
                  {{
                    item.createdAt
                      ? new Date(item.createdAt).toLocaleDateString()
                      : ""
                  }}
                </template>
                <template v-slot:[`item.duration`]="{ item }">
                  {{ item.duration }}
                </template>
                <template v-slot:[`item.employeeCode`]="{ item }">
                  {{ company.abbrv + "-" + item.id }}
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <div class="dropdown dropdown-action">
                    <a
                      href="#"
                      class="action-icon dropdown-toggle"
                      data-toggle="dropdown"
                      aria-expanded="false"
                      ><i class="material-icons">more_vert</i></a
                    >
                    <div class="dropdown-menu dropdown-menu-right">
                      <a
                        class="dropdown-item"
                        @click="setLeaveStatus(item)"
                        v-if="item.status == 0"
                        ><i class="fa fa-pencil m-r-5"></i> Approve or Reject</a
                      >
                    </div>
                  </div>
                </template>
              </v-data-table>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Approve Leave Modal -->
        <v-dialog v-model="dialogStatus" max-width="500px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Employee Probation Extension Approve</h3>
                <p>Are you sure want to approve for this employee extension?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click="changeLeaveStatus(1)"
                      class="btn btn-primary continue-btn"
                      >Approve</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      @click="changeLeaveStatus(2)"
                      data-dismiss="modal"
                      class="btn btn-primary cancel-btn"
                      >Decline</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required, numeric, sameAs } from "vuelidate/lib/validators";
import { employeeService } from "@/services/employeeService.js";
import { authenticationService } from "@/services/authenticationService";
import { organizationService } from "@/services/organizationService";
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker,
  },
  data() {
    return {
      company: authenticationService.currentOfficeValue,
      firstName: "",
      lastName: "",
      rankId: null,
      address: "",
      phone: "",
      email: "",
      requestDate: new Date(),
      designationId: null,
      companyunitId: null,
      media: "data:image/jpeg;base64,",
      headers: [
        {
          text: "Name",
          value: "profile",
        },
        { text: "Employee Code", value: "employeeCode" },
        { text: "Email", value: "probatedEmployee.employee.email" },
        { text: "Extension Date", value: "createdAt" },
        { text: "Duration", value: "duration" },
        { text: "Action", value: "actions", sortable: false },
      ],
      probatedEmployees: [],
      employee: {},
      submitted: false,
      loading: false,
      dialogStatus: false,
      error: "",
      message: "",
      dialog: false,
      dialogEdit: false,
      dialogConfirm: false,
      dialogDelete: false,
      dialogImport: false,
      fileName: "",
      comment: "",
      probationExtensionMonth: "",
      currentUserId: {},
      currentUserFullName: "",
      currUserData: {},
    };
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    // dialogEdit(val) {
    //   val || this.closeEdit();
    // },
  },
  created() {
    this.getCurrentUser();
  },

  methods: {
    getCurrentUser() {
      let currentUser = JSON.parse(localStorage.getItem("currentUser"));
      this.currentUserId = currentUser.employee;
      this.currentUserFullName =
        currentUser.employee.firstName + " " + currentUser.employee.lastName;
      console.log(this.currentUserId);
    },
    getProbatedEmployees() {
      this.loading = true;
      let unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.GetProbatedEmployeesExtension(unit.id).then(
        (model) => {
          console.log(model);
          this.probatedEmployees = model.filter((c) => c.status == 0);
        },
        (error) => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    changeLeaveStatus(status) {
      this.submitted = true;
      this.employee.status = status;
      this.employee.approvedByHR = this.currentUserId.id;
      this.employee.approvedDateByHR = new Date();
      const id = this.employee.id;
      console.log(this.employee);
      this.loading = true;
      employeeService.updateProbatedEmployeeExtension(id, this.employee).then(
        (id) => {
          var unit = JSON.parse(localStorage.getItem("companyUnit"));
          employeeService
            .GetProbatedEmployeesExtension(unit.id)
            .then((model) => {
              this.probatedEmployees = model.filter((c) => c.status == 0);
              this.closeStatus();
            });

          console.log("employee approved", this.employee);
        },
        (error) => {
          this.error = error;
          this.closeStatus();
          this.loading = false;
        }
      );
    },

    setLeaveStatus(item) {
      this.employee = item;
      this.dialogStatus = true;
      // console.log(`item`, item)
    },

    close() {
      this.dialogEdit = false;
      // this.clearModel();
    },
    closeStatus() {
      this.dialogStatus = false;
    },

    openDialog() {
      this.dialog = true;
    },

    closeDelete() {
      this.dialogDelete = false;
    },
  },

  mounted() {
    this.getProbatedEmployees();
  },
  name: "employeeslist",
};
</script>


// WEBPACK FOOTER //
// src/components/employees/ProbationExtensionList.vue